import { kambiAuthApi } from '../adapters/base'
import { kambiSessionManager } from './kambiSessionManager'

class KambiAuthService {
  constructor() {
    if (KambiAuthService.instance) {
      return KambiAuthService.instance
    }
    KambiAuthService.instance = this
  }

  async getSessionToken(forceRefresh = false) {
    return kambiSessionManager.getSessionToken(forceRefresh)
  }

  async makeAuthenticatedRequest(endpoint, options = {}) {
    const sessionResponse = await this.getSessionToken()
    if (!sessionResponse.ok) {
      return sessionResponse
    }

    try {
      const response = await kambiAuthApi.request({
        url: endpoint,
        ...options,
        headers: {
          ...options.headers,
          Authorization: `Bearer ${sessionResponse.data}`,
        },
      })

      return { ok: true, data: response.data }
    } catch (error) {
      if (error?.response?.status === 401) {
        const refreshResponse = await this.getSessionToken(true)
        if (!refreshResponse.ok) {
          return refreshResponse
        }

        try {
          const retryResponse = await kambiAuthApi.request({
            url: endpoint,
            ...options,
            headers: {
              ...options.headers,
              Authorization: `Bearer ${refreshResponse.data}`,
            },
          })

          return { ok: true, data: retryResponse.data }
        } catch (retryError) {
          return {
            ok: false,
            error:
              retryError?.response?.data ||
              retryError?.message ||
              'Request failed after token refresh',
          }
        }
      }

      return {
        ok: false,
        error: error?.response?.data || error?.message || 'Request failed',
      }
    }
  }
}

export const kambiAuthService = new KambiAuthService()
